import { motion } from "framer-motion";

const HeroSection = ({ service }) => {
  return (
    <section className="relative h-[300px] sm:h-[340px] lg:h-[380px] overflow-hidden">
      {/* Background Image */}
      <img
        src={service.heroImage}
        alt={service.title}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#031224]/95 via-[#08203E]/75 to-[#08203E]/35" />

      {/* Content */}
      <div className="relative z-10 h-full">
        <div className="max-w-[1400px] mx-auto h-full px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center h-full"
          >
            <div className="max-w-[560px]">
              {/* Badge */}
              <span className="inline-flex items-center rounded-full bg-white/95 px-5 py-2 text-[10px] font-semibold uppercase tracking-[2px] text-[#0A5EA8] shadow-md">
                {service.tagline}
              </span>

              {/* Heading */}
              <h1 className="mt-5 text-[34px] sm:text-[42px] lg:text-[50px] font-bold leading-[1.08] tracking-[-1px] text-white">
                {service.title}
              </h1>

              {/* Description */}
              <p className="mt-5 max-w-[500px] text-[15px] lg:text-[16px] leading-7 text-gray-200">
                {service.shortDesc}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;